import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { LockIcon, PlugIcon, SplitIcon } from 'lucide-react';
import { deploymentPrinciples, episodeChapters } from '../data/abbviePro';
import { AbbVieHeroPlayer } from './AbbVieHeroPlayer';
const iconMap = {
  embed: PlugIcon,
  gate: LockIcon,
  split: SplitIcon
};
export function DeploymentMechanicsScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-white px-6 py-20" aria-labelledby="deployment-title" data-id="element-186" data-mp="19wifpr6pte0k">
      <div className="mx-auto w-full max-w-7xl" data-id="element-187" data-mp="15vyiknm56aef">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-188" data-mp="1jm1y6vqin5uw">05 - Deployment mechanics</p>
        <h2 id="deployment-title" className="max-w-2xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-189" data-mp="1ev20vpdhilrv">
          Ship inside the portal you already have
        </h2>

        <div className="mt-14 grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-center" data-id="element-190" data-mp="r2uzucwtdqm4">
          <div className="grid gap-4" data-id="element-191" data-mp="m41wvef5li07">
            {deploymentPrinciples.map((principle, index) => {
            const Icon = iconMap[principle.icon as keyof typeof iconMap];
            return <motion.div key={principle.title} initial={reduceMotion ? false : {
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.22,
              delay: index * 0.05,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex gap-4 rounded-2xl border border-slate-200 bg-presentation-canvas p-5" data-id="element-192" data-mp="dyj0ggtods6h" data-mpi={index}>
                  <Icon className="h-5 w-5 shrink-0 text-abbvie-cyan" aria-hidden="true" data-id="element-193" data-mp="3w55q44cbz1eh" />
                  <div data-id="element-194" data-mp="42ocd66on4wb">
                    <h3 className="font-bold text-abbvie-navy" data-id="element-195" data-mp="43zi3bjoumq2">{principle.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-slate-500" data-id="element-196" data-mp="1beybwlto4l9n">{principle.detail}</p>
                  </div>
                </motion.div>;
          })}
          </div>

          <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-197" data-mp="3ch67ljoxp3ql">
            <AbbVieHeroPlayer chapters={episodeChapters} gated exampleLabel="SKYRIZI - Finland / Denmark example" data-id="element-198" data-mp="3gjt07mtfisou" />
            <p className="mt-4 text-sm leading-relaxed text-slate-500" data-id="element-199" data-mp="2stqc1hsmy6vi">Toggle "Watch" vs "Read" above to see the parallel lean-back or text pathway - and preview how gated markets unlock content.</p>
          </motion.div>
        </div>
      </div>
    </section>;
}